import MeetingRegisterORM from "@/store/orm-axios/models/MeetingRegister";

export default {
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      //
    } else {
      return new Promise((resolve, reject) => {
        MeetingRegisterORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
